import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { LOCALE_ID, importProvidersFrom } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

import { routes } from './app.routes';
import { AuthInterceptor } from './core/auth/interceptors/auth.interceptor';

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      theme: {
          preset: Aura,
          options: {
              darkModeSelector: '.my-app-dark'
          }
      },
      translation: {
        startsWith: 'Inizia con',
        contains: 'Contiene',
        notContains: 'Non contiene',
        endsWith: 'Termina con',
        equals: 'È uguale a',
        notEquals: 'È diverso da',
        noFilter: 'Nessun filtro',
        lt: 'Minore di',
        lte: 'Minore o uguale a',
        gt: 'Maggiore di',
        gte: 'Maggiore o uguale a',
        is: 'È',
        isNot: 'Non è',
        before: 'Prima del',
        after: 'Dopo il',
        dateIs: 'Data uguale al',
        dateIsNot: 'Data diversa dal',
        dateBefore: 'Data precedente al',
        dateAfter: 'Data successiva al',
        clear: 'Pulisci',
        apply: 'Applica',
        matchAll: 'Tutti i criteri',
        matchAny: 'Qualsiasi criterio',
        addRule: 'Aggiungi condizione',
        removeRule: 'Rimuovi condizione',
        accept: 'Conferma',
        reject: 'Annulla',
        choose: 'Seleziona',
        upload: 'Carica file',
        cancel: 'Annulla',
        dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
        monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
        monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
        today: 'Oggi',
        weekHeader: 'Sett',
        firstDayOfWeek: 1,
        dateFormat: 'dd/mm/yy',
        weak: 'Debole',
        medium: 'Medio',
        strong: 'Forte',
        passwordPrompt: 'Inserisci password',
        emptyFilterMessage: 'Nessun risultato',
        emptyMessage: 'Nessun risultato'
      }
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'it-IT' }
  ]
};
